export const scramble = arr => {
  const copy = [...arr];
  const length = arr.length;
  const moveTo = () => Math.floor(Math.random() * length);

  for (let i = 0; i < length; i++) {
    const a = copy[i];
    let j = moveTo();
    const b = copy[j];
    copy[i] = b;
    copy[j] = a;
  }

  return copy;
};



// WEBPACK FOOTER //
// ./src/components/quiz/scramble.js